/* MDL Sample Choice - Musk de Lumiere (v3, September 28, 2026)
   With every 50 ml bottle the customer chooses one complimentary 2.5 ml sample; a Pair carries two.
   The choice is kept in the cart attribute 'Complimentary sample' (names joined with ', '), as before,
   so the order's Additional details keep showing it for packing.
   New in v3:
   1. A default. A sample not chosen is the house's choice, and the bag says so in words.
   2. Confirmation through checkout. The samples are also written as a line item property on one
      bottle line ('Complimentary samples, 2.5 ml: Hayal, Royale Oud' or 'Chosen by the house'),
      which Shopify shows under that bottle in the checkout summary and on the order.
   3. A quieter bag. The chooser is a short list of names that folds away once every sample is
      chosen, with one line that says what was chosen and a Change button.
   Layers over the bag drawer in sections/mdl-header-lv.liquid and the bag page picker. */
(function () {
  'use strict';
  if (window.__MDL_SAMPLE_CHOICE__) return;
  window.__MDL_SAMPLE_CHOICE__ = true;

  var ATTR = 'Complimentary sample';
  var SEP = ', ';
  var FULL = /(^|[^0-9.])50 ?ml/i;
  var PAIR_SKU = /^MDL-PAIR/i;
  var MAX = 8;
  var OBS = { childList: true, subtree: true, attributes: true, attributeFilter: ['hidden'] };
  /* every language's property names, so a bag that changes language is cleaned up too */
  var OUR_KEYS = ['Complimentary sample, 2.5 ml', 'Complimentary samples, 2.5 ml', 'Muestra de cortesía, 2.5 ml', 'Muestras de cortesía, 2.5 ml'];
  var cart = null, pend = null, chain = null, mo = null, sig = '', tid = null, noteUntil = 0;
  var open = null, lastN = -1, busyMirror = false, mirrorFails = 0, foldTid = null;

  function I18N() { return window.mdlI18n || {}; }
  function tt(k, fallback, vars) {
    var v = I18N()[k] || fallback; vars = vars || {};
    return String(v).replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) { return vars[key] != null ? vars[key] : m; });
  }
  function words(n) { var l = (I18N().numbers || '|One|Two|Three|Four|Five|Six|Seven|Eight').split('|'); var w = l[n] || String(n); return w.charAt(0).toUpperCase() + w.slice(1); }
  function join(arr) {
    if (arr.length < 2) return arr.join('');
    return arr.slice(0, -1).join(', ') + ' ' + (I18N().and || 'and') + ' ' + arr[arr.length - 1];
  }

  function list() { var s = window.mdlhSamples; return (s && s.length) ? s : []; }
  function names() { return list().map(function (p) { return p.t; }); }

  function isPair(it) {
    return (it.product_type || '') === 'Pair' || PAIR_SKU.test(it.sku || '') || /· The Pair$/.test(it.product_title || '');
  }
  function eligible(it) { return isPair(it) || FULL.test(it.variant_title || ''); }
  /* How many complimentary samples this bag has earned. */
  function entitled() {
    var it = (cart || {}).items || [], n = 0, i, q;
    for (i = 0; i < it.length; i++) {
      q = it[i].quantity || 1;
      if (isPair(it[i])) n += 2 * q;
      else if (FULL.test(it[i].variant_title || '')) n += q;
    }
    return Math.min(n, MAX);
  }

  function parse(v) {
    var out = [], known = names(), parts = String(v || '').split(SEP), i, p;
    for (i = 0; i < parts.length; i++) {
      p = parts[i].trim();
      if (p && known.indexOf(p) > -1 && out.indexOf(p) < 0) out.push(p);
    }
    return out;
  }
  function savedList() { return parse(((cart || {}).attributes || {})[ATTR]); }
  function chosenList() { return pend !== null ? pend.slice() : savedList(); }

  /* the words for what travels with the bottles: names, then the house's choice for the rest */
  function valueFor(sel, n) {
    var k = sel.length, r = n - k;
    if (n <= 0) return '';
    if (k === 0) return r === 2 ? tt('spHouseBoth', 'Both chosen by the house') : r > 1 ? tt('spHouseMany', '{{ count }}, chosen by the house', { count: words(r) }) : tt('spHouseOne', 'Chosen by the house');
    if (r <= 0) return sel.join(SEP);
    return sel.join(SEP) + SEP + (r > 1 ? tt('spHouseRestMany', '{{ count }} chosen by the house', { count: words(r).toLowerCase() }) : tt('spHouseRestOne', 'one chosen by the house'));
  }
  function keyFor(n) { return n > 1 ? tt('spKeyMany', 'Complimentary samples, 2.5 ml') : tt('spKeyOne', 'Complimentary sample, 2.5 ml'); }
  function isOurKey(k) { return OUR_KEYS.indexOf(k) > -1 || k === keyFor(1) || k === keyFor(2); }

  function getCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); }).then(function (c) { cart = c; return c; });
  }
  function track(n, d) {
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish(n, d || {}); } catch (e) {}
    try { (window.dataLayer = window.dataLayer || []).push({ event: n, sample: (d || {}).sample || '', count: (d || {}).count || 0 }); } catch (e) {}
  }
  function set(arr, changed) {
    var run = function () {
      pend = arr.slice(); paint();
      var a = {}; a[ATTR] = arr.join(SEP);
      return fetch('/cart/update.js', {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes: a })
      }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
        .then(function (c) {
          cart = c; pend = null; noteUntil = 0; paint();
          if (changed) track(changed.added ? 'mdl_sample_chosen' : 'mdl_sample_cleared', { sample: changed.name, count: arr.length });
        })
        .catch(function () { pend = null; paint(); note(tt('spError', 'That did not save. Please try again.'), true); });
    };
    chain = chain ? chain.then(run, run) : run();
    return chain;
  }

  /* ---------- the line item property that carries the samples to checkout ---------- */
  function cleanProps(p) {
    var o = {}, k;
    if (!p) return o;
    for (k in p) { if (Object.prototype.hasOwnProperty.call(p, k) && !isOurKey(k) && p[k] != null && p[k] !== '') o[k] = p[k]; }
    return o;
  }
  function sameProps(a, b) {
    var x = cleanAll(a), y = cleanAll(b), ka = Object.keys(x).sort(), kb = Object.keys(y).sort(), i;
    if (ka.length !== kb.length) return false;
    for (i = 0; i < ka.length; i++) { if (ka[i] !== kb[i] || String(x[ka[i]]) !== String(y[kb[i]])) return false; }
    return true;
  }
  function cleanAll(p) { var o = {}, k; if (!p) return o; for (k in p) { if (Object.prototype.hasOwnProperty.call(p, k) && p[k] != null && p[k] !== '') o[k] = p[k]; } return o; }
  function carries(it) { var p = it.properties || {}, k; for (k in p) { if (Object.prototype.hasOwnProperty.call(p, k) && isOurKey(k) && p[k]) return true; } return false; }

  function mirror() {
    if (!cart || pend !== null || busyMirror || mirrorFails > 2) return;
    var items = cart.items || [], n = entitled(), sel = savedList().slice(0, n), i, it, anchor = null;
    for (i = 0; i < items.length; i++) { if (eligible(items[i]) && items[i].final_line_price > 0 && carries(items[i])) { anchor = items[i]; break; } }
    if (!anchor && n > 0) { for (i = 0; i < items.length; i++) { if (eligible(items[i]) && items[i].final_line_price > 0) { anchor = items[i]; break; } } }
    if (!anchor && n > 0) { for (i = 0; i < items.length; i++) { if (eligible(items[i])) { anchor = items[i]; break; } } }
    for (i = 0; i < items.length; i++) {
      it = items[i];
      var want = cleanProps(it.properties);
      if (n > 0 && anchor && it.key === anchor.key) want[keyFor(n)] = valueFor(sel, n);
      if (!sameProps(it.properties, want)) { change(it, want); return; }
    }
  }
  var stamps = [];
  function change(it, props) {
    var now = Date.now(); stamps = stamps.filter(function (s) { return now - s < 15000; });
    if (stamps.length >= 6) { mirrorFails = 9; return; } /* something keeps rewriting the line: stop, the attribute still carries the choice */
    stamps.push(now);
    busyMirror = true;
    fetch('/cart/change.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: it.key, quantity: it.quantity, properties: props })
    }).then(function (r) { if (!r.ok) throw 0; return r.json(); })
      .then(function (c) {
        cart = c; busyMirror = false; mirrorFails = 0;
        try { if (typeof window.mdlhCartRender === 'function' && document.getElementById('mdlhCd') && document.getElementById('mdlhCd').classList.contains('open')) window.mdlhCartRender(); } catch (e) {}
        paint();
      })
      .catch(function () { busyMirror = false; mirrorFails++; });
  }

  /* ---------- words ---------- */
  function title(n) { return n > 1 ? tt('spTitleMany', 'Your {{ count }} complimentary samples, 2.5 ml', { count: words(n).toLowerCase() }) : tt('spTitleOne', 'Your complimentary sample, 2.5 ml'); }
  function heading(n) {
    return n > 1 ? tt('chooseSamples', 'Choose your {{ count }} complimentary 2.5 ml samples', { count: words(n).toLowerCase() }) : tt('chooseSample', 'Choose your complimentary 2.5 ml sample');
  }
  function label(sel, n) {
    if (n <= 1) return sel.length ? sel[0] + ' ' + tt('spAdded', '· 2.5 ml, added to your order') : tt('spOneHouse', 'One 2.5 ml sample, on the house. Tap to choose.');
    if (!sel.length) return tt('spManyHouse', '{{ count }} 2.5 ml samples, on the house. Tap to choose {{ count_lower }}.', { count: words(n), count_lower: words(n).toLowerCase() });
    if (sel.length < n) return tt('spPartial', '{{ n }} of {{ total }} chosen · {{ names }}. Tap another.', { n: sel.length, total: n, names: join(sel) });
    return join(sel) + ' ' + tt('spAddedEach', '· 2.5 ml each, added to your order');
  }

  function note(msg, isError) {
    noteUntil = Date.now() + 6000;
    var e = document.getElementById('mdlhCdChosen');
    if (e) { e.hidden = false; e.className = 'mdlh__cd-chosen ' + (isError ? 'is-error' : 'is-on'); e.textContent = msg; }
    var p = document.querySelector('.mdl-sample-picker .mdl-sp__chosen');
    if (p) { p.hidden = false; p.className = 'mdl-sp__chosen ' + (isError ? 'is-error' : 'is-on'); p.textContent = msg; }
  }

  /* ---------- the bag drawer ---------- */
  function cell(p, idx, sel, n) {
    var on = sel.indexOf(p.t) > -1, b = document.createElement('button'), s = document.createElement('span');
    b.type = 'button';
    b.className = 'mdlh__cd-cell' + (on ? ' is-on' : '') + (idx > 3 ? ' is-dark' : '');
    b.setAttribute('role', n > 1 ? 'checkbox' : 'radio');
    b.setAttribute('aria-checked', on ? 'true' : 'false');
    b.setAttribute('data-mdl-sample', p.t);
    s.textContent = p.t;
    b.appendChild(s);
    return b;
  }
  function frame(sec) {
    var grid = document.getElementById('mdlhCdGrid'), head = sec.querySelector('.mdlh__cd-sh'), sub = sec.querySelector('.mdlh__cd-sub');
    if (!head) {
      head = document.createElement('div'); head.className = 'mdlh__cd-sh';
      if (sub) head.appendChild(sub); else { sub = document.createElement('span'); sub.className = 'mdlh__cd-sub'; head.appendChild(sub); }
      var tg = document.createElement('button'); tg.type = 'button'; tg.className = 'mdlh__cd-toggle'; tg.id = 'mdlhCdToggle';
      tg.setAttribute('aria-controls', 'mdlhCdGrid');
      head.appendChild(tg);
      sec.insertBefore(head, sec.firstChild);
    }
    var st = document.getElementById('mdlhCdChosen');
    if (!st) { st = document.createElement('p'); st.id = 'mdlhCdChosen'; st.setAttribute('role', 'status'); head.parentNode.insertBefore(st, head.nextSibling); }
    var hint = document.getElementById('mdlhCdHint');
    if (!hint) { hint = document.createElement('p'); hint.id = 'mdlhCdHint'; hint.className = 'mdlh__cd-hint'; st.parentNode.insertBefore(hint, st.nextSibling); }
    if (grid && grid.previousSibling !== hint) sec.appendChild(grid);
    return { head: head, sub: sub, toggle: document.getElementById('mdlhCdToggle'), st: st, hint: hint, grid: grid };
  }
  function drawer() {
    var sec = document.getElementById('mdlhCdSample'), grid = document.getElementById('mdlhCdGrid');
    if (!sec || !grid || !cart) return;
    var ls = list(), n = entitled(), show = ls.length > 0 && n > 0, sel = chosenList().slice(0, n);
    if (mo) mo.disconnect();
    sec.hidden = !show;
    if (show) {
      var f = frame(sec);
      if (n !== lastN) { if (n > lastN && sel.length < n) open = true; lastN = n; }
      if (open === null) open = sel.length < n;
      grid.setAttribute('role', n > 1 ? 'group' : 'radiogroup');
      grid.setAttribute('aria-label', heading(n));
      grid.hidden = !open;
      sec.classList.toggle('is-open', !!open);
      var t = title(n); if (f.sub.textContent !== t) f.sub.textContent = t;
      f.toggle.textContent = open ? tt('spDone', 'Done') : (sel.length ? tt('spChange', 'Change') : tt('spChoose', 'Choose'));
      f.toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      var next = sel.join('|') + '#' + n + '#' + ls.length;
      if (next !== sig || !grid.querySelector('[data-mdl-sample]')) {
        grid.textContent = '';
        ls.forEach(function (p, idx) { grid.appendChild(cell(p, idx, sel, n)); });
        sig = next;
      }
      if (Date.now() > noteUntil) {
        f.st.hidden = false;
        f.st.className = 'mdlh__cd-chosen' + (sel.length ? ' is-on' : '');
        f.st.textContent = valueFor(sel, n);
      }
      f.hint.hidden = !open;
      f.hint.textContent = sel.length >= n ? tt('spFullHint', 'Tap a name to change it.') : tt('spHint', 'Tap to choose. If you do not, the house chooses for you.');
    } else { sig = ''; lastN = 0; open = null; }
    if (mo) mo.observe(sec, OBS);
  }

  /* ---------- the bag page picker ---------- */
  function page() {
    var sec = document.querySelector('.mdl-sample-picker');
    if (!sec || !cart) return;
    var n = entitled(), show = n > 0;
    sec.style.display = show ? '' : 'none';
    if (!show) return;
    var sel = chosenList().slice(0, n), cells = sec.querySelectorAll('[data-mdl-sample]'), i, on, b;
    var grid = sec.querySelector('.mdl-sp__grid');
    if (grid) { grid.setAttribute('role', n > 1 ? 'group' : 'radiogroup'); grid.setAttribute('aria-label', heading(n)); }
    var sub = sec.querySelector('.mdl-sp__sub');
    if (sub && n > 1) sub.textContent = tt('spSubMany', 'With every bottle, a 2.5 ml sample of your choice is on the house. Your bag carries {{ count }}, so choose {{ count }}.', { count: words(n).toLowerCase() });
    for (i = 0; i < cells.length; i++) {
      on = sel.indexOf(cells[i].getAttribute('data-mdl-sample')) > -1;
      cells[i].classList.toggle('is-on', on);
      cells[i].setAttribute('role', n > 1 ? 'checkbox' : 'radio');
      cells[i].setAttribute('aria-checked', on ? 'true' : 'false');
      b = cells[i].querySelector('.mdl-sp__add');
      if (b) b.textContent = on ? tt('spSelected', 'Selected') : b.getAttribute('data-idle') || tt('spSelect', 'Select');
    }
    var st = sec.querySelector('.mdl-sp__chosen');
    if (st && Date.now() > noteUntil) {
      st.hidden = false; st.className = 'mdl-sp__chosen' + (sel.length ? ' is-on' : '');
      st.textContent = sel.length ? label(sel, n) + (sel.length < n ? ' ' + valueFor(sel, n) : '') : valueFor(sel, n) + '. ' + (n > 1 ? tt('spTapMany', 'Tap {{ count }} to choose them.', { count: words(n).toLowerCase() }) : tt('spTapOne', 'Tap one to choose it.'));
    }
  }

  function paint() {
    drawer(); page();
    if (!cart || pend !== null) return;
    var n = entitled(), s = savedList(), raw = ((cart || {}).attributes || {})[ATTR] || '';
    if (n === 0 && raw) { set([]); return; }             /* no bottle left: no sample owed */
    if (n > 0 && s.length > n) { set(s.slice(0, n)); return; } /* a Pair or bottle was removed: keep only what is earned */
    if (n > 0 && raw && s.join(SEP) !== raw) { set(s); return; }   /* legacy or unknown names: normalise once */
    mirror();
  }

  function hit(node) {
    while (node && node !== document) {
      if (node.nodeType === 1 && node.hasAttribute && node.hasAttribute('data-mdl-sample')) return node;
      node = node.parentNode;
    }
    return null;
  }
  function fold() { clearTimeout(foldTid); foldTid = setTimeout(function () { open = false; drawer(); }, 650); }
  function pick(e, el) {
    e.preventDefault();
    var name = el.getAttribute('data-mdl-sample'), n = entitled(), sel = chosenList().slice(0, n), at = sel.indexOf(name);
    if (n === 0) return;
    clearTimeout(foldTid);
    if (at > -1) { sel.splice(at, 1); set(sel, { added: false, name: name }); return; }
    if (n === 1) { set([name], { added: true, name: name }); if (el.closest('#mdlhCdSample')) fold(); return; }
    if (sel.length >= n) { note(tt('spFull', 'You have {{ count }} samples chosen. Tap one to change it.', { count: words(n).toLowerCase() })); return; }
    sel.push(name); set(sel, { added: true, name: name });
    if (sel.length >= n && el.closest('#mdlhCdSample')) fold();
  }
  document.addEventListener('click', function (e) {
    var tg = e.target && e.target.closest ? e.target.closest('#mdlhCdToggle') : null;
    if (tg) { e.preventDefault(); clearTimeout(foldTid); open = !open; drawer(); return; }
    var el = hit(e.target); if (el) { e.stopPropagation(); pick(e, el); }
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
    var el = hit(e.target); if (el) pick(e, el);
  });

  function soon() { clearTimeout(tid); tid = setTimeout(function () { if (busyMirror) { soon(); return; } getCart().then(paint).catch(function () {}); }, 90); }
  function wrap() {
    var o = window.mdlhCartOpen;
    if (typeof o !== 'function' || o.__mdlSample) return;
    var w = function (e) { var r; try { r = o(e); } catch (x) { r = false; } soon(); return r; };
    w.__mdlSample = true;
    window.mdlhCartOpen = w;
  }
  /* every bag change on the site is answered by a fresh read, so the property keeps up */
  (function () {
    var _f = window.fetch;
    if (!_f || _f.__mdlSample) return;
    var w = function () {
      var u = arguments[0]; var url = (typeof u === 'string') ? u : (u && u.url) || '';
      var p = _f.apply(this, arguments);
      if (!busyMirror && /\/cart\/(add|change|clear)(\.js)?(\?|$)/.test(url)) { p.then(function (r) { if (r && r.ok) soon(); }).catch(function () {}); }
      return p;
    };
    w.__mdlSample = true;
    try { window.fetch = w; } catch (e) {}
  })();
  function init() {
    var sec = document.getElementById('mdlhCdSample');
    if (sec && !mo) { mo = new MutationObserver(soon); mo.observe(sec, OBS); }
    wrap(); setTimeout(wrap, 800);
    getCart().then(paint).catch(function () {});
    window.addEventListener('pageshow', soon);
    document.addEventListener('cart:refresh', soon);
    document.addEventListener('eurus:cart:updated', soon);
    document.addEventListener('mdl:offer:settled', soon);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
